'use strict';

angular.module('app')
	.controller('FaqCtrl', function(Request) {
		vm = this;

		Request.get('faq/').then(function(res) {
			vm.data = res.data;
		});
	});